import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';
import { QueryType } from 'app/enums/query-type.enum';

@Component({
  selector: 'app-aggregation-block',
  templateUrl: './aggregation-block.component.html',
  styleUrls: ['./aggregation-block.component.scss'],
})
export class AggregationBlockComponent implements OnChanges, OnInit {
  @Input() aggregation: any;
  @Output() onChange: EventEmitter<ElasticQuery> = new EventEmitter<ElasticQuery>();
  @Input() expanded = true;
  @Input() activeKeys: any[] = [];
  labels: Array<string> = [];

  constructor() {}

  ngOnInit() {
    this.activeKeys = this.activeKeys || [];

    if (this.aggregation.Meta.values) {
      this.labels = JSON.parse(this.aggregation.Meta.values);
    }

    if (this.aggregation.selectedValues) {
      this.activeKeys = this.aggregation.selectedValues || [];
      if (this.activeKeys.length > 0) {
        this.expanded = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {}

  toggleKey(e, item) {
    if (e.value) {
      this.activeKeys.push(e.key);
      item.checked = true;
    } else {
      this.activeKeys.splice(this.activeKeys.indexOf(e.key), 1);
      item.checked = false;
    }
    this.aggregation.selectedValues = this.activeKeys;

    this.onChange.emit({
      Type: this.aggregation.Meta.type === 'nested' ? QueryType.NESTED : QueryType.CHECKBOX,
      Field: this.aggregation.Meta.title,
      Values: this.activeKeys,
    });
  }
}
